import { Badge, Box, Text } from '@chakra-ui/react';
import { useActiveSession } from '@texas/hooks/useSession';
import { useTranslation } from 'react-i18next';

export function FeatureGuard({
  children,
  hideBadge = false,
  textBadge = false,
  optOut = false,
}: {
  children: React.ReactNode;
  hideBadge?: boolean;
  textBadge?: boolean;
  optOut?: boolean;
}) {
  const session = useActiveSession();
  const { t } = useTranslation();

  if (optOut) {
    return <>{children}</>;
  }

  if (session.currentUser.betaFeatures) {
    if (hideBadge) {
      return <>{children}</>;
    }

    return (
      <Box pos="relative" h="100%">
        {textBadge ? (
          <Text
            pos="absolute"
            zIndex={1}
            right={-2}
            top={-2}
            color="texas.sand.100"
            fontSize="xs"
            fontWeight="semibold"
            _light={{ color: 'texas.burntSienna.500' }}
          >
            {t('user.beta')}
          </Text>
        ) : (
          <Badge
            bg="texas.sand.100"
            color="white"
            pos="absolute"
            zIndex={1}
            right={-2}
            top={-3}
            pointerEvents="none"
            border="1px solid"
            borderColor="texas.sand.50"
            _light={{
              bg: 'texas.burntSienna.200',
              borderColor: 'texas.burntSienna.100',
            }}
          >
            {t('user.beta')}
          </Badge>
        )}
        {children}
      </Box>
    );
  }

  return null;
}
